import React from 'react';
import ProFlowAddressComponentV2 from '../../../../../../tarifications/src/legacy/ProFlowAddressComponentV2';
import { Address } from '../../../../../../../types/Common';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}

interface DriverAddressAnswer {
  address?: Address;
}

const DriverAddressInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { value, onBlur },
    error,
  } = useFlowInputComponent({
    question,
  });

  const handleOnSelect = (address: Address) => {
    onBlur({ name: question.id, value: { ...address } });
  };

  return (
    <ProFlowAddressComponentV2
      error={error?.message}
      value={(value as DriverAddressAnswer)?.address}
      onSubmit={handleOnSelect}
      updateOnChange
    />
  );
};

export default DriverAddressInputComponent;
